<template>
  <div>
    <v-container fluid>
      <div style="overflow: auto">
      <v-row style="width:960px; margin: auto;" no-gutters>
        <v-col v-if="job.id != null">
          <v-card outlined class="mx-auto mt-6" style="border: none">
            <v-row>
              <v-col cols="12" class="job_name">
                {{job.name}}
              </v-col>
              <v-col cols="12" class="px-9 display-flex">
                <div class="mr-2">
                  <v-img v-if="company.logoUrl" :src="company.logoUrl" contain height="50px" width="50px" class="logo_icon mr-1" />
                </div>
                <div  style="align-item: center">
                  <span class="company_name">{{company.name}}</span><br>
                  <span v-if="company.url" class="company_url"><a :href="company.url" target="_blank">{{company.url}}</a></span>
                </div>
              </v-col>
            </v-row>
            <v-row style="padding-left: 12px; border-top: 1px solid #00000007">
                <v-img v-if="job.image1" max-width="320" max-height="180px" :src="job.image1.url" />
                <v-img v-else max-width="320" max-height="180px" src="@/assets/no_image_white.png" />
                <v-img v-if="job.image2" max-width="319" max-height="180px" :src="job.image2.url" />
                <v-img v-else max-width="319" max-height="180px" src="@/assets/no_image_gray.png" />
                <v-img v-if="job.image3" max-width="319" max-height="180px" :src="job.image3.url" />
                <v-img v-else max-width="319" max-height="180px" src="@/assets/no_image_white.png" />
            </v-row>
          </v-card>

          <v-row class="mt-6">
            <v-col>
              <v-tabs grow icons-and-text v-model="tab">
                <v-tab key="detail">
                  {{label("tabDetail")}}
                </v-tab>
                <v-tab key="company">
                  {{label("tabCompany")}}
                </v-tab>
              </v-tabs>
              <v-tabs-items :touchless="true" v-model="tab">
                <v-tab-item key="detail">
                  <JobDetail v-if="job" :job="job" />
                </v-tab-item>
                <v-tab-item key="company">
                  <CompanyProfileDetails :company="company" />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>

          <v-row v-if="isApplicant">
            <v-col class="px-5 text-center">
              <JobFavoriteButton :jobId=job.id :isLiked="job.isLiked"/>
              <JobCasualMeetingButton
                  v-if="job.casualMeetingAvailable && job.side == null"
                  :jobId=job.id :application-status="job.applicationStatus" :jobType="jobType"/>
              <JobCandidateButton :jobId=job.id :application-status="job.applicationStatus" :jobType="jobType"/>
            </v-col>
          </v-row>

          <v-row v-if="!isClient">
            <JobDetailRecommendPanel :recommend-jobs="recommendJobs" />
          </v-row>
        </v-col>

        <v-col v-if="notFoundJob">
          <v-card outlined class="mx-auto">
            <v-row>
              <v-col cols="12" class="job_name py-12">
                この求人は非公開、ないし掲載期間が終了しています
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" offset="3">
                <ActionButton @click="onClose">閉じる</ActionButton>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import ComponentMixin from "../../ComponentMixin";
import { mapGetters } from "vuex";
import ApiMixin from "../../../ApiMixin";
import JobDetail from "../../organisms/JobDetail";
import JobCandidateButton from "../../molecules/JobCandidateButton";
import JobFavoriteButton from "../../molecules/JobFavoriteButton";
import JobCasualMeetingButton from "../../molecules/JobCasualMeetingButton";
import CompanyProfileDetails from "../../organisms/CompanyProfileDetails";
import ActionButton from "@/components/molecules/ActionButton";
import JobDetailRecommendPanel from '../../organisms/JobDetailRecommendPanel'

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "JobPage",
  components: {
    JobDetailRecommendPanel,
    ActionButton,
    JobDetail,
    JobCandidateButton,
    JobFavoriteButton,
    JobCasualMeetingButton,
    CompanyProfileDetails,
  },
  data () {
    return {
      tab: null,
      notFoundJob: false,
    }
  },
  props: {
    client: {
      type: Boolean,
      default: false
    },
    draft: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("jobs", ["job", "randomJobs"]),
    ...mapGetters("system", ["consts"]),
    isClient () {
      return !!this.$route.meta.isClient
    },
    lang() {
      return this.$i18n.locale
    },
    isApplicant () {
      return !this.client;
    },
    jobType() {
      return this.job.side == null ? 'main' : 'side'
    },
    recommendJobs() {
      return this.randomJobs
    },
    company() {
      return this.job.company || {}
    }
  },
  methods: {
    pageUrl() {
      const jobId = this.$route.params.id
      return `https://connect.nishika.com/jobs/${jobId}`
    },
    pageTitle() {
      if (this.job) {
        return this.job.name;
      }
      return undefined;
    },
    fetchJob() {
      const jobId = this.$route.params.id
      this.loadJob(jobId, this.draft).then(() => {
        this.loadRandomJobs(jobId, 3).then(res => {
          this.recommends = res
        })
      })
        .catch(res => {
        if (res.response.status === 404) {
          this.notFoundJob = true;
        }
      });
    },
    onClose() {
      open(location, '_self').close();
    }
  },
  watch: {
    "$route.params.id": {
      handler: function() {
        if(!this.draft || this.$auth.isAuthenticated){
          this.fetchJob();
        }
      }
    },
    "$auth.loading": {
      handler: function (loading) {
        if ( (!loading && !this.draft) || this.$auth.isAuthenticated) {
          this.fetchJob();
        }
      },
      immediate: true
    },
    "$auth.isAuthenticated": {
      handler: function(isAuthenticated) {
        if (isAuthenticated && !this.$auth.loading ) {
          this.fetchJob();
        }
      }
    },
    "job": {
      handler: function (job) {
        if (job) {
          this.setMetaData()
        }
      }
    }
  },
};
</script>

<style scoped lang="sass">
.job_name
  font-weight: bold
  font-size: 24px
  padding: 16px 36px 0 36px
.company_name
  color: rgba(0, 0, 0, 0.54)
  margin-top: 4px
  margin-bottom: -4px
.company_url
  font-size: 12.8px
.logo_icon
  border-radius: 50%
.display-flex
  display: flex
  align-items: center
</style>
